/***************** SLIDER ******************/
 
  $('.bd-slider').each(function () {
    const slider = $(this); 
    console.log(slider, 'Slider');
    const slidesToScroll = slider.data('slide-size') ? Number(slider.data('slide-size')) : 1;
    const slidesToShow = slider.data('slide-size') ? Number(slider.data('slide-size')) : 1;
    const slidesToScrollMobile = slider.data('slide-size-mobile') ? Number(slider.data('slide-size-mobile')) : 1;
    const slidesToShowMobile = slider.data('slide-size-mobile') ? Number(slider.data('slide-size-mobile')) : 1;
    const arrows = slider.data('arrows') == true ? true : false;
    const dots = slider.data('dots') == true ? true : false;
    //console.log('DOTS', dots);
    const fade = slider.data('fade') == true ? true : false;
    const adaptiveHeight = slider.data('adaptive-height') == true
      ? true
      : false;
      //console.log(slidesToShowMobile,'AH');
    const navfor = slider.data('nav-for') ? slider.data('nav-for') : false;
    const freeScroll = slider.data('free-scroll') == true
      ? true
      : false;
    const wrapAround = slider.data('wrap-around') == true
      ? true 
      : false;
    const initialIndex = slider.data('initial-index')
      ? Number(slider.data('initial-index'))
      : 0;
    const cellAlign = slider.data('cell-align')
      ? slider.data('cell-align')
      : 'left';
    const autoPlay = slider.data('autoplay')  == true ? true : false;
    const autoPlaySpeed = slider.data('autoplay-speed') ? Number(slider.data('autoplay-speed')) : 1000;
    const watchCSS = slider.data('watch-css')
      ? slider.data('watch-css')
      : false;

    // console.log(slider.data('arrows'));

    slider.on('init', function(event, slick){
     //console.log('slick loaded', event);
    });

    const data = {
      rows: 0,
      arrows: arrows,
      slidesToScroll: slidesToScroll,
      slidesToShow: slidesToShow, 
      dots: dots,
      fade: fade,
      lazyLoad: 'ondemand',
      adaptiveHeight: adaptiveHeight,
      asNavFor: navfor, 
      infinite: wrapAround,
      initialSlide: initialIndex,
      autoplay: autoPlay, 
      autoplaySpeed: autoPlaySpeed, 
      responsive: [{ 
        breakpoint: 759,
        settings: {
          slidesToScroll: slidesToScrollMobile,
          slidesToShow: slidesToShowMobile,
        } 
      }
      ] 
    }

    console.log('slider data', data);
    slider.slick(data);  
  }); // END EACH 